import React from 'react'

import styles from './styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { useTranslation } from 'react-i18next'

const MixrItem = ({ rank, selectedCategory, mixrId, eventName, value, numberOfParticipants, eventPicture }) => {
  const { t } = useTranslation()
  const handleClick = (e) => {
    if (!mixrId) {
      e.preventDefault()
    }
  }

  return (
    <AnchorLink
      className={styles.succesfulMixr}
      path={mixrId > 0 ? `/0/home/event/${mixrId}` : ''}
      handleClick={handleClick}
      isReactLink={true}>
      <img className={styles.trophy} src={`${config.assetUrl}/images/rate${rank}.svg`} />
      <div
        className={`${styles.mixrPicture} ${eventPicture ? null : styles['defaultImage']}`}
        style={
          eventPicture
            ? {
                backgroundImage: `url(${eventPicture})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover'
              }
            : null
        }
        alt={eventName}
      />
      <div className={styles.mixrInfo}>
        <p className={styles.mixrName}>{eventName}</p>
        <div className={styles.rating}>
          <div className={styles.yellowValue}>
            {selectedCategory.value === 'participation_ratio'
              ? t('dashboard.activity.newMixrs.participantCount', {
                  count: parseInt(numberOfParticipants)
                })
              : t('dashboard.activity.newEngagements.engagedCount', { count: value })}
          </div>
        </div>
      </div>
    </AnchorLink>
  )
}
export default MixrItem
